import { styled } from '@mui/system';
import { Box, TableRow, TableHead, TableCell, Typography } from '@mui/material';

export const StyledTableContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.hover,
  borderRadius: theme.spacing(1),
  overflow: 'auto',
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.colors.borderBottom}`,
  top: 0,
  backgroundColor: theme.palette.background.hover,
  zIndex: 1,
}));

export const StyledRowHead = styled(TableRow)(({ theme }) => ({
  color: theme.palette.text.secondary,
  height: '36px',
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.colors.gray,
  padding: theme.spacing(1, 2),
  whiteSpace: 'nowrap', // Avoid breaking the text

  '& .MuiTableSortLabel-icon': {
    color: theme.colors.gray,
  },
  '& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {
    color: theme.colors.gray,
  },
  '& .MuiTableSortLabel-root:hover': {
    color: theme.palette.primary.main,
  },
}));

export const TitleTable = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
}));
